import { ThemeSchemaResponse } from '@api';
import { SendAllAssetsTo } from '@terminal/components/send-all-assets-to/SendAllAssetsTo';
import { POSTHOG_TRACKING_SOURCES } from '@terminal/services/tracking/posthog/constants';
import { useColumns } from '@terminal/views/theme-overview/tab-content/companies/knowledge-graph/companies-table/utils';
import { CompaniesTableData } from '@terminal/views/theme-overview/types';
import { useTranslation } from 'react-i18next';
import { CompaniesTable } from './companies-table/CompaniesTable';
import styles from './KnowledgeGraph.module.scss';

export const KnowledgeGraph = ({
  data,
  theme,
}: {
  data: CompaniesTableData;
  theme: ThemeSchemaResponse;
}) => {
  const { t } = useTranslation(['widget', 'common']);

  const columns = useColumns();

  const customSendAllAssetsLabelText = t(
    'widget:sendAllAssetsTo.sendAssetsButtonLabel'
  );
  const selectedRowsLabelText = t('widget:themeOverview.numberOfCompanies', {
    totalNumber: data.length,
  });

  const companiesExposureTitle = t(
    'widget:themeOverview.exposureNumberOfCompaniesTitle',
    {
      totalNumber: data.length,
      themeName: theme.name,
    }
  );

  const entityTags = data.map(company => company.company);

  return (
    <div
      className={styles.knowledgeGraphRoot}
      data-testid="theme-overview-knowledge-graph"
    >
      <div className={styles.contentTitle}>{companiesExposureTitle}</div>
      <div className={styles.labelAndTableWrapper}>
        <div className={styles.headerRowWrapper}>
          <div className={styles.selectedRowsLabel}>
            {selectedRowsLabelText}
          </div>
          <SendAllAssetsTo
            entityTags={entityTags}
            customLabel={customSendAllAssetsLabelText}
            source={POSTHOG_TRACKING_SOURCES.THEME_OVERVIEW}
          />
        </div>
        <CompaniesTable columns={columns} data={data} />
      </div>
    </div>
  );
};
